import styled from "styled-components";
import { setFlex, setPosition } from "../variables/utils";
import { BREAKPOINTS, desktop, mobile } from "../variables/breakpoints";
import { COLOURS } from "../variables/colours";

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  padding: 3.5rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 0 3.5rem;
    height: 95svh;
    width: 100vw;
  }

  @media (max-width: ${BREAKPOINTS.xs}px) {
    padding: 0;
  }
`;

export const Container = styled.div`
  ${setFlex({ direction: "column", align: "center", justify: "center" })};
  width: 100%;
  height: 100%;
`;

export const HeadlineImage = styled.img`
  width: auto;
  image-rendering: -webkit-optimize-contrast;
  margin-bottom: 2rem;
`;

export const HeadingWrapper = styled.div`
  ${setFlex({ direction: "column", align: "center", justify: "center" })};
  ${desktop}
`;

export const HeadlineContainer = styled.div`
  ${setFlex({ justify: "center", align: "anchor-center" })};
`;

export const Headline = styled.h2`
  font-family: "univers-bold-cond";
  font-size: 2.5rem;
  line-height: 2.5rem;
  font-style: normal;
  text-transform: uppercase;
  color: ${COLOURS.primary.black};
`;

export const BodegaLandingScene = styled.div`
  ${setFlex({})};
  width: 135px;
  height: 8vh;
  margin: 0 0.5rem;
  @media (max-width: ${BREAKPOINTS.xxl}px) {
    width: 125px;
  }
`;

export const BodegaImageWrapper = styled.div`
  ${setPosition({ position: "absolute" })};
  ${setFlex({ justify: "center", align: "center" })};
  width: 135px;
  @media (max-width: ${BREAKPOINTS.xxl}px) {
    width: 125px;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setPosition({ position: "relative" })};
    width: 100%;
    height: 100%;
  }
`;

export const BodegaImageContainer = styled.div`
  ${setPosition({ position: "absolute" })};
  ${setFlex({ justify: "center", align: "center" })};
  will-change: transform;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setPosition({ position: "relative" })};
    height: 100%;
    width: 100%;
  }
`;

export const BodegaImage = styled.img`
  ${setPosition({ position: "relative" })};
  width: 100%;
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: -webkit-fill-available;
    margin-bottom: 1rem;
    width: auto;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    height: auto;
    width: -webkit-fill-available;
    padding: 2rem 0.75rem;
  }
`;

export const SubheadingContainer = styled.div`
  ${setPosition({ position: "absolute", bottom: -25, left: "0", zIndex: 5 })};
  width: 100%;
  ${props =>
    props.$desktop &&
    `
    @media (max-width: ${BREAKPOINTS.sm}px) {
    display: none;
    }
    @media (min-width: ${BREAKPOINTS.sm + 1}px) {
      opacity: 0;
    }
`};
  ${props => props.$mobile && mobile};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 2rem 2rem 1.5rem 2rem;
    width: -webkit-fill-available;
    bottom: 0;
  }
`;

export const BodegaSubheading = styled.h3`
  color: ${props => props.$fontColor || COLOURS.primary.black};
  width: 100%;
  text-align: center;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: ${COLOURS.primary.black};
  font-family: "universltpro-bold";
  font-size: 7rem;
  line-height: 7rem;
  font-style: normal;
  font-weight: 100;
  letter-spacing: -5px;
  margin: 0;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    text-align: left;
    font-size: 5rem;
    line-height: 4.5rem;
    margin-bottom: 1rem;
  }
`;
